import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { AppConfig } from '../interfaces/app-config.interface';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    static settings?: AppConfig; // có thể undefined ban đầu

    constructor(private http: HttpClient) { }

    async load(): Promise<void> {
        await this.getAppConfig().toPromise().then(data => {
            if (data) {
                AppConfigService.settings = data;
            }
        });
    }

    getAppConfig(): Observable<AppConfig> {
        const jsonFile = '/assets/config.json';
        return this.http.get<AppConfig>(jsonFile).pipe(timeout(15000));
    }
}

